
import React, { useState, useEffect } from 'react';

import '../css/listOfFilesPopUp.css';
import SearchableDropdown from '../SearchableDropdown';


import {
  showCatalogSchemas, showCatalogSchemasTables, showCatalogSchemasTablesColumns,
  fetchSqliteListTables, fetchSqliteListColumns
} from '../authorization/FetchToken';

function ListOfFilesLoadPopupComponent({ loadDatabaseList, setLoadDatabaseList, loadTableList,
  setLoadTableList,
  node, onClose, schema, setSchema, table,
  setTable, chunk, setChunk, delimeter, setDelimeter, onValueSubmit }) {

  console.log(JSON.stringify(loadDatabaseList) + "loadDatabaseList");
  console.log(JSON.stringify(loadTableList) + "loadTableList");

  const loadDatabaseListOptions = loadDatabaseList.map(item => ({
    label: item,
    value: item,
  }));

  console.log(JSON.stringify(loadDatabaseListOptions) + "loadDatabaseListOptions");

  const renderSchemasOptions = () => {
    return loadTableList.map((schema, index) => (
      <option key={index} value={schema}>
        {schema}
      </option>
    ));
  };

  const dropDownFields = [
    // { value: '', label: 'Select a window function' },
    { value: 'append', label: 'Append' },
    { value: 'replace', label: 'Replace' },
    { value: 'fail', label: 'Fail' },


    // Add more window functions as needed
  ];

  const fileFormatType = [
    // { value: '', label: 'Select a window function' },
    { value: 'csv', label: 'csv' },
    { value: 'json', label: 'json' },
    { value: 'excel', label: 'excel' },
    { value: 'parquet', label: 'parquet' }
    // Add more window functions as needed
  ];

  const [ifTableExists, setIfTableExists] = useState(dropDownFields[0].value);
  const [chunkSize, setChunkSize] = useState('');
  const [fileFormatTypeValue, setFileFormatTypeValue] = useState(fileFormatType[0].value);
  const [schemaDropdown, setSchemaDropdown] = useState(loadDatabaseListOptions.length > 0 ? loadDatabaseListOptions[0].value : []);

  const [isTableEmpty, setIsTableEmpty] = useState(false);

  useEffect(() => {
    setSchemaDropdown(schemaDropdown);
    setSchema(schema);
    setTable(table);
    setFileFormatTypeValue(fileFormatTypeValue);
    setIfTableExists(ifTableExists);
    setChunkSize(chunkSize);
  }, [schema, table, fileFormatTypeValue, ifTableExists, chunkSize]
  );

  const handleSubmit = () => {
    // Implement your logic here for handling the form submission
    // You can access schema, table, chunk, delimeter, and columnType values here
    console.log('Schema:', schema);
    console.log('schemaDropdown:', schemaDropdown);

    console.log('Table:', table);
    console.log('FileFormatType:', fileFormatTypeValue);
    console.log('Delimeter:', delimeter);
    console.log('Chunk:', chunkSize);
    console.log('ifTableExists:', ifTableExists);
    // console.log('ColumnType:', columnType);
    onValueSubmit(onClose, schemaDropdown, table, fileFormatTypeValue, chunkSize, ifTableExists);
    // Close the popup
    onClose();
  };

  const handleTableChange = async (event) => {
    const schema = event.target.value;

    setTable(schema);
  };
  const handleDBListChange = async (value) => {
    // const schema = event.target.value;
    setSchemaDropdown(value);

    if (loadDatabaseListOptions.some(item => item.value === value)) {

      let tableNames = [];
      let columnNames = [];
      tableNames = await fetchSqliteListTables(value);
      console.log(JSON.stringify(tableNames) + "tableNames");
      if (tableNames.length > 0) {
        setLoadTableList(tableNames);
        setTable(tableNames[0]);
        setIsTableEmpty(false);
      } else {
        setTable(tableNames);
        setIsTableEmpty(true);
      }
    } else {
      setIsTableEmpty(true);
    }



    //  setTable(tableNames);

    // setSchema(schema);
  };



  return (
    <div className="overlay">

      <div className="file-popup-datatable">
        {/* <div className="popup-header"> */}



        <div className="input-container">
          <h1>Input Fields</h1>
          <div className="input-row">
            <label className="file-fields" htmlFor="schema">Database:</label>

            <SearchableDropdown className="labelTag"

              options={loadDatabaseListOptions}
              label="label"
              id="value"
              value={schemaDropdown}
              selectedVal={schemaDropdown}
              handleChange={(event) => handleDBListChange(event)}
            //  handleChange={(e) => setSchemaDropdown(e)}
            />

            {/* <input className="file-fields-input" type="text" id="schema" value={schema} onChange={(e) => setSchema(e.target.value)} />
         */}
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="table">Table:</label>
            {isTableEmpty ? (
              <input
                className="file-fields-input"
                type="text"
                id="table"
                value={table}
                onChange={(e) => setTable(e.target.value)}
              />
            ) : (
              <select
                id="database"
                className="form-control"
                value={table}
                onChange={handleTableChange}
              >
                {/* Options for the select dropdown */}
                {renderSchemasOptions()}
              </select>
            )}
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">FileFormatType : </label>

            <select
              id={`dropdown`}
              className="form-control"
              value={fileFormatTypeValue}

              onChange={(event) => setFileFormatTypeValue(event.target.value)}
            >
              {fileFormatType.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">Delimeter:</label>
            <input className="file-fields-input" type="text" id="delimeter" value={delimeter} onChange={(e) => setDelimeter(e.target.value)} />
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">Chunk Size:</label>
            <input className="file-fields-input" type="text" id="chunk" value={chunkSize} onChange={(e) => setChunkSize(e.target.value)} />
          </div>
          <div className="input-row">
            <label className="file-fields" htmlFor="chunk">If Table exists : </label>

            <select
              id={`dropdown`}
              className="form-control"
              value={ifTableExists}
              onChange={(event) => setIfTableExists(event.target.value)}
            >
              {dropDownFields.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

          </div>

          <div>
            <textarea
              id="editor"
              rows="5"
              cols="50"
              value={''}
              placeholder="Change your columntype here"

            >

            </textarea>
          </div>
          <button type="button" onClick={handleSubmit}>SUBMIT</button>
          <button type="button" onClick={onClose}>CLOSE</button>

        </div>

      </div>
      {/* </div> */}
    </div>
  );
}

export default ListOfFilesLoadPopupComponent;
